module.exports = __webpack_public_path__ + "img/结构映射.f33da43e.svg";